export const confirmWarningConfig = {
  icon: "mdi-information-outline",
  title: "Achtung!",
  buttonTrueText: "Bestätigen",
  buttonFalseText: "Abbrechen",
  buttonFalseColor: "#7a7a7a",
  buttonTrueColor: "#444444",
  color: "#c55c52"
};
